/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_DeltaInputs */

const en_audit_delta = /** @type {(inputs: Audit_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta`)
};

const es_audit_delta = /** @type {(inputs: Audit_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delta`)
};

/**
* | output |
* | --- |
* | "Delta" |
*
* @param {Audit_DeltaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_delta = /** @type {((inputs?: Audit_DeltaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_DeltaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_delta(inputs)
	return es_audit_delta(inputs)
});